import CenteredForm from "../../components/forms/centered_form/CenteredForm";
import OauthIcons from "../../components/forms/oauth_icons/OauthIcons";
import { Form, Button, Spinner, Col, Row } from 'react-bootstrap';
import { useVerifyUser, useSignup } from "../../api/query_hooks";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Divider from "../../components/layout/divider/Divider";
import { UserContext } from "../../contexts/UserContext";
import { useContext, useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';

const Signup = () => {

    const { user } = useContext(UserContext);
    const navigate = useNavigate();

    const [birthDate, setBirthDate] = useState(new Date());
    const [firstName, setFirstName] = useState("example");
    const [lastName, setLastName] = useState("example");
    const [formError, setFormError] = useState("");
    const [username, setUsername] = useState("");
    const [category, setCategory] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [step, setStep] = useState(0);
    const [tin, setTin] = useState("");

    const signupMutation = useSignup();  // mutation to perform signup
    const verificationMutation = useVerifyUser(); // mutation to perform mail verification after signup

    const handleSignup = async (e) => {
        e.preventDefault();
        setFormError("");

        signupMutation.mutate({username, email, password, category});
    };

    const submitCode = async (e) => {
        e.preventDefault();

        verificationMutation.mutate({code});
    };

    useEffect(() => {   // redirecting if the user is already logged in at page load
        if(user.isLogged) {
            navigate('/account');
        }
    }, []);


    return (
        <>
            {!signupMutation.isSuccess &&
                <CenteredForm onSubmit={handleSignup}>

                    {step === 0 &&
                        <>
                            <div className="d-flex flex-column justify-content-center align-items-center col-12">
                                <h1 className="mb-4">Sign up</h1>
                            </div>

                            <Button 
                                variant="link" 
                                className={"text-decoration-none hov-bg-2 d-flex justify-content-center align-items-center px-3 py-3 border-2 border-secondary"} 
                                onClick={() => setStep(prev => prev+1)}
                                aria-describedby="business"
                            >
                                <span className="fs-4">Create new account</span>
                            </Button>

                            <div className="d-flex flex-row justify-content-center align-items-center col-6">
                                <div className="col-4"><Divider length={12} /></div>
                                <p className="fs-6 text-white-50 user-select-none mx-4 mt-2 my-auto">or</p>
                                <div className="col-4"><Divider length={12} /></div>
                            </div>

                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <p className="fs-6 text-white-50 user-select-none">Sign up with:</p>
                                <OauthIcons />
                            </div>

                            <div className="col-12 d-flex flex-column justify-content-center align-items-center gap-2">
                                <Divider length={10} />
                                <Link className="link-light" to={'/login'}>
                                    Already have an account? Log in!
                                </Link>
                            </div>
                        </>
                    }

                    {step === 1 &&
                        <>
                            <h3 className="mb-4">Account info</h3>
                            
                            <Form.Group className="mb-2 col-11 col-lg-8" controlId="usernameBox" >
                                <Form.Label className="mx-3 text-white-50">username</Form.Label>
                                <Form.Control className="bg-darker bg-dark" type="text" placeholder="Username" onChange={e => setUsername(e.target.value)} aria-describedby="username" />
                            </Form.Group>

                            <Form.Group className="mb-2 col-11 col-lg-8" controlId="mailBox" >
                                <Form.Label className="mx-3 text-white-50">email</Form.Label>
                                <Form.Control className="bg-darker bg-dark" type="email" placeholder="account@example.com" onChange={e => setEmail(e.target.value)} aria-describedby="email" />
                            </Form.Group>

                            <Form.Group className="mb-4 col-11 col-lg-8" controlId="passwordBox" >
                                <Form.Label className="mx-3 text-white-50">password</Form.Label>
                                <Form.Control className="bg-darker bg-dark" type="password" placeholder="password" onChange={e => setPassword(e.target.value)} aria-describedby="password" />
                            </Form.Group>

                            <div className="d-flex justify-content-between align-items-center col-11 col-lg-8 mb-4">
                                <Button variant="dark" className="px-4 px-lg-3 border-secondary" type="button" onClick={() => setStep(prev => prev-1)} aria-describedby="back">
                                    <span>Back</span>
                                </Button>
                                <Button variant="warning" className="px-4 px-lg-3" type="button" aria-describedby="next" onClick={() => setStep(prev => prev+1)}>
                                    Next
                                </Button>
                            </div>

                            
                            
                            <p className="text-danger">
                                {signupMutation.isError && signupMutation.error.response?.data}
                                {(formError !== "") && formError}
                            </p>
                        </>
                    }

                    {step === 2 &&
                        <>
                            <h3 className="mb-4">Choose a category</h3>
                        
                            <div className="d-flex flex-column gap-1 mb-4">
                                <div className="d-flex gap-1">
                                    <Button 
                                        variant="link" 
                                        className={"position-relative hov-bg-2 d-flex justify-content-center align-items-center p-5 border-2 "+((category === "artist") ? "border-warning" : "border-secondary")}warning
                                        onClick={() => setCategory("artist")}
                                        aria-describedby="artist"
                                    >
                                        <box-icon size="md" type='solid' name='palette' color='white' ></box-icon>
                                        <span className="position-absolute bottom-0 mb-4">Artist</span>
                                    </Button>
                                    <Button 
                                        variant="link" 
                                        className={"position-relative hov-bg-2 d-flex justify-content-center align-items-center p-5 border-2 "+((category === "professional") ? "border-warning" : "border-secondary")} 
                                        onClick={() => setCategory("professional")}
                                        aria-describedby="professional"
                                    >
                                        <box-icon size="md" name='briefcase-alt-2' type='solid' color='white' ></box-icon>
                                        <span className="position-absolute bottom-0 mb-4">Professional</span>
                                    </Button>
                                </div>
                                <div className="d-flex gap-1">
                                    <Button 
                                        variant="link" 
                                        className={"position-relative hov-bg-2 d-flex justify-content-center align-items-center p-5 border-2 "+((category === "business") ? "border-warning" : "border-secondary")} 
                                        onClick={() => setCategory("business")}
                                        aria-describedby="business"
                                    >
                                        <box-icon size="md" name='business' type='solid' color='white' ></box-icon>
                                        <span className="position-absolute bottom-0 mb-4">Business</span>
                                    </Button>
                                    <Button 
                                        variant="link" 
                                        className={"position-relative hov-bg-2 d-flex justify-content-center align-items-center p-5 border-2 "+((category === "collector") ? "border-warning" : "border-secondary")} 
                                        onClick={() => setCategory("collector")}
                                        aria-describedby="collector"
                                    >
                                        <box-icon size="md" type='solid' name='diamond' color='white' ></box-icon>
                                        <span className="position-absolute bottom-0 mb-4">Collector</span>
                                    </Button>
                                </div>
                                <div className="d-flex gap-1">
                                    <Button 
                                        variant="link" 
                                        className={"position-relative hov-bg-2 d-flex justify-content-center align-items-center p-5 border-2 "+((category === "non-profit") ? "border-warning" : "border-secondary")}
                                        onClick={() => setCategory("non-profit")}
                                        aria-describedby="non-profit"
                                    >
                                        <box-icon size="md" name='bank' type='solid' color='#ffffff' ></box-icon>
                                        <span className="position-absolute bottom-0 mb-4">Non-profit</span>
                                    </Button>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center col-11 col-lg-8 mb-4">
                                <Button variant="dark" className="px-4 px-lg-3 border-secondary" type="button" onClick={() => setStep(prev => prev-1)} aria-describedby="back">
                                    <span>Back</span>
                                </Button>
                                <Button variant="warning" className="px-4 px-lg-3" type="button" aria-describedby="next" onClick={() => setStep(prev => prev+1)} disabled={!category}>
                                    <span className="text-dark">Next</span>
                                </Button>
                            </div>
                        </>
                    }

                    {step === 3 &&
                        <>
                            <h3>Personal info</h3>

                            <Form.Group className="mb-2 col-11 col-lg-8" controlId="firstNameBox" >
                                <Form.Label className="mx-3 text-white-50">first name</Form.Label>
                                <Form.Control className="bg-darker bg-dark" type="text" placeholder="First name" onChange={e => setFirstName(e.target.value)} aria-describedby="first name" />
                            </Form.Group>

                            <Form.Group className="mb-2 col-11 col-lg-8" controlId="lastNameBox" >
                                <Form.Label className="mx-3 text-white-50">last name</Form.Label>
                                <Form.Control className="bg-darker bg-dark" type="text" placeholder="Last name" onChange={e => setLastName(e.target.value)} aria-describedby="last name" />
                            </Form.Group>

                            {["artist", "professional", "collector"].includes(category) &&
                                <Form.Group className="d-flex flex-column mb-2 col-11 col-lg-8" controlId="birthDateBox" >
                                    <Form.Label className="mx-3 text-white-50">birth date (mm/dd/yyyy)</Form.Label>
                                    <DatePicker className="bg-darker bg-dark col-12 p-1 rounded shadow-none" selected={birthDate} onChange={(date) => setBirthDate(date)} />
                                </Form.Group>
                            }

                            {["professional", "business"].includes(category) &&
                                <Form.Group className="mb-2 col-11 col-lg-8" controlId="tinBox" >
                                    <Form.Label className="mx-3 text-white-50">TIN</Form.Label>
                                    <Form.Control className="bg-darker bg-dark" type="text" onChange={e => setTin(e.target.value)} aria-describedby="TIN" />
                                </Form.Group>
                            }

                            <div className="d-flex justify-content-between align-items-center col-11 col-lg-8 mt-2 mb-4">
                                <Button variant="dark" className="px-4 px-lg-3 border-secondary" type="button" onClick={() => setStep(prev => prev-1)} aria-describedby="back">
                                    <span>Back</span>
                                </Button>
                                <Button variant="warning" className="px-4 px-lg-3" type="submit" aria-describedby="sign up" disabled={signupMutation.isFetching}>
                                    {signupMutation.isFetching && <Spinner size="sm" animation="border" role="status" />}
                                    {!signupMutation.isFetching && <span className="text-dark">Sign up</span>}
                                </Button>
                            </div>
                        </>
                    }

                </CenteredForm>
            }


            {(signupMutation.isSuccess && !verificationMutation.isSuccess) &&
                <CenteredForm onSubmit={submitCode}>
                    <div className="col-10 d-flex flex-column justify-content-center align-items-center">
                        <h2 className="mb-5">Confirm email</h2>

                        <p className="text-center">An confirmation code has been sent to your email address. Please, type it below to confirm your account</p>
                    </div>

                    <Form.Group className="mb-2 col-11 col-lg-8" controlId="codeBox" >
                        <Form.Label className="mx-3 text-white-50">verification code</Form.Label>
                        <Form.Control className="bg-darker bg-dark" type="text" onChange={e => setCode(e.target.value)} aria-describedby="verification code" />
                    </Form.Group>

                    <Button variant="warning" className="mb-4 px-4 px-lg-3" type="submit" aria-describedby="submit code" disabled={verificationMutation.isFetching}>
                        {verificationMutation.isFetching && <Spinner size="sm" animation="border" role="status" />}
                        {!signupMutation.isFetching && <span className="text-dark">Confirm</span>}
                    </Button>
                    <Link to={'/account'} className="text-white-50" >
                        Confirm later
                    </Link>
                </CenteredForm>
            }


            {verificationMutation.isSuccess &&
                <Navigate to={'/account'} />
            }
        </>
    );
}

export default Signup;